import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { isProductConfigurable } from '@magento/peregrine/lib/util/isProductConfigurable';
export var getDimensions = function getDimensions(product) {
  return product !== null && product !== void 0 && product.hf_height && product !== null && product !== void 0 && product.hf_width && product !== null && product !== void 0 && product.hf_depth_length ? "".concat(product === null || product === void 0 ? void 0 : product.hf_height, " x ").concat(product === null || product === void 0 ? void 0 : product.hf_width, " x ").concat(product === null || product === void 0 ? void 0 : product.hf_depth_length) : null;
};
export var searchParamsToObject = function searchParamsToObject(search) {
  return Object.fromEntries(new URLSearchParams(search));
};

function preventDefault(e) {
  e.preventDefault();
}

export var addScrollToBody = function addScrollToBody() {
  var toTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var $body = document.querySelector('body');
  $body.style.removeProperty('overflow');
  document.body.removeEventListener('touchmove', preventDefault);

  if (toTop) {
    $body.style.removeProperty('position');
    $body.style.removeProperty('top');
    $body.style.removeProperty('width');
    window.scrollTo(0, 0);
  }
};
export var removeScrollFromBody = function removeScrollFromBody() {
  var _document$getElementB;

  var toTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  var elementId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'scroll-element';
  document.body.addEventListener('touchmove', preventDefault, {
    passive: false
  });
  (_document$getElementB = document.getElementById(elementId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.addEventListener('touchmove', function (e) {
    e.stopPropagation();
  }, {
    passive: false
  });
  var $body = document.querySelector('body');
  $body.style.overflow = 'hidden';

  if (toTop) {
    $body.style.position = 'fixed';
    $body.style.top = "-".concat(window.pageYOffset, "px");
    $body.style.width = '100%';
  }
};
export var bodyScrollHide = function bodyScrollHide() {
  var $body = document.querySelector('body');
  $body.style.overflow = 'hidden';
  $body.style.width = '100%';
};
export var bodyScrollIndicate = function bodyScrollIndicate() {
  var $body = document.querySelector('body');
  $body.style.removeProperty('overflow');
  $body.style.removeProperty('width');
};
export var formatUsPhone = function formatUsPhone(phone) {
  var phoneTest = new RegExp(/^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/);
  phone = phone.trim();
  var results = phoneTest.exec(phone);

  if (results !== null && results.length > 8) {
    return '+1 ' + '(' + results[3] + ') ' + results[4] + '-' + results[5] + (typeof results[8] !== 'undefined' ? ' x' + results[8] : '');
  } else {
    return phone;
  }
}; // Line art drawings are the scale/dimension images of the media gallery. They
// follow the <prefix>_5[_<n>].<ext> naming convention, which is also what puts
// them fifth in the PDP image carousel.

var LINE_ART_IMAGE_NUMBER = 5;

var extractImageNumber = function extractImageNumber(url) {
  var result = url === null || url === void 0 ? void 0 : url.match(/\/([^\/_]*_(\d+))/);
  return result ? parseInt(result[2], 10) : null;
}; // Media gallery urls point at a resized cache entry, so dropping the cache
// segment resolves the original, full resolution asset.


var getOriginalImageUrl = function getOriginalImageUrl(url) {
  return url === null || url === void 0 ? void 0 : url.replace(/\/cache\/[^\/]+\//, '/');
};

export var getLineArtDownload = function getLineArtDownload(product) {
  var _product$media_galler, _lineArt$url$match;

  var lineArt = product === null || product === void 0 ? void 0 : (_product$media_galler = product.media_gallery) === null || _product$media_galler === void 0 ? void 0 : _product$media_galler.find(function (image) {
    return extractImageNumber(image === null || image === void 0 ? void 0 : image.url) === LINE_ART_IMAGE_NUMBER;
  });

  if (!lineArt) {
    return null;
  }

  var extension = ((_lineArt$url$match = lineArt.url.match(/\.([a-z0-9]+)$/i)) === null || _lineArt$url$match === void 0 ? void 0 : _lineArt$url$match[1]) || 'png';
  return {
    url: getOriginalImageUrl(lineArt.url),
    filename: "".concat(product.sku, "-dimensional-drawing.").concat(extension)
  };
};
export var checkIfImageIsAvailable = function checkIfImageIsAvailable(request) {
  var filteredData = [];

  if (!Array.isArray(request)) {
    var _request$images;

    filteredData.push({
      product_sku: request === null || request === void 0 ? void 0 : request.product_sku,
      images: _toConsumableArray(request === null || request === void 0 ? void 0 : (_request$images = request.images) === null || _request$images === void 0 ? void 0 : _request$images.filter(function (img) {
        return !img.url.includes('missing_image');
      }))
    });
  } else {
    filteredData = _toConsumableArray(request.map(function (data) {
      return _objectSpread(_objectSpread({}, data), {}, {
        images: data.images.filter(function (img) {
          return !img.url.includes('missing_image');
        })
      });
    }));
  }

  filteredData = filteredData.filter(function (data) {
    return data.images.length > 0;
  });
  return filteredData;
};
export var generateDownloadUrlSuccess = function generateDownloadUrlSuccess(data) {
  if (data.generateDownloadUrlM.generated_download_url_output) {
    var _data$generateDownloa = data.generateDownloadUrlM.generated_download_url_output,
        status = _data$generateDownloa.status,
        download_url = _data$generateDownloa.download_url;

    if (status === 'ok') {
      window.open(download_url, '_blank');
    }
  }
};
export var scrollToTop = function scrollToTop() {
  return window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
export var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
export var formatDate = function formatDate(date) {
  var today = new Date(date.replace(/\s/, 'T'));
  var yyyy = today.getFullYear();
  var mm = today.getMonth() + 1;
  var dd = today.getDate();
  if (dd < 10) dd = '0' + dd;
  if (mm < 10) mm = '0' + mm;
  return "".concat(mm, "/").concat(dd, "/").concat(yyyy);
};
export var deriveOptionSelectionsFromProduct = function deriveOptionSelectionsFromProduct(product, INITIAL_OPTION_SELECTIONS) {
  var _product$media_galler2, _defaultImageFile, _product$variants$fin;

  if (!isProductConfigurable(product)) {
    return INITIAL_OPTION_SELECTIONS;
  } // Jola customized logic - for HubbardtonForge, the requirement for the configurable products
  // is such that when a visitor lands on the page, some default configuration should be selected.
  // Default configuration should be a product variant derived from the name of the main image
  // in the base/config product. The name of the image should match the value  of the 'hf_smart_string'
  // attribute
  // let defaultImage = product.media_gallery_entries.find(


  var defaultImage = product === null || product === void 0 ? void 0 : (_product$media_galler2 = product.media_gallery) === null || _product$media_galler2 === void 0 ? void 0 : _product$media_galler2.find(function (image) {
    var _image$url;

    return (image === null || image === void 0 ? void 0 : (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.split('/').reverse()[0].replace(/^.*?[_]/, '').replace(/\.[^/.]+$/, '').replace(/_[0-9]+?$/, '')) == '1';
  });
  var defaultImageFile = null;

  if (!defaultImage) {
    if (product !== null && product !== void 0 && product.media_gallery) {
      var _product$media_galler3;

      defaultImageFile = product === null || product === void 0 ? void 0 : (_product$media_galler3 = product.media_gallery[0]) === null || _product$media_galler3 === void 0 ? void 0 : _product$media_galler3.url;
    }
  } else {
    defaultImageFile = defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.url;
  } // const productMainImageFile = product.media_gallery_entries[0]?.file.replace(/^.*[\\\/]/, '');


  var productMainImageFile = (_defaultImageFile = defaultImageFile) === null || _defaultImageFile === void 0 ? void 0 : _defaultImageFile.replace(/^.*[\\\/]/, '');
  var targetSmartString = productMainImageFile === null || productMainImageFile === void 0 ? void 0 : productMainImageFile.substring(0, productMainImageFile.indexOf('_')); // if we cannot match the variant by smart string (maybe its disabled or out of stock/sale)
  // just take the first available variant as a failsafe

  var targetVariant = (_product$variants$fin = product.variants.find(function (variant) {
    var _variant$product;

    return (variant === null || variant === void 0 ? void 0 : (_variant$product = variant.product) === null || _variant$product === void 0 ? void 0 : _variant$product.hf_smart_string) == targetSmartString;
  })) !== null && _product$variants$fin !== void 0 ? _product$variants$fin : product.variants[0];
  var urlArguments = new URLSearchParams(window.location.search);
  var selectedVariant = urlArguments === null || urlArguments === void 0 ? void 0 : urlArguments.get('selected_variant');

  if (selectedVariant) {
    var _product$variants$fin2;

    targetVariant = (_product$variants$fin2 = product.variants.find(function (variant) {
      var _variant$product2;

      return (variant === null || variant === void 0 ? void 0 : (_variant$product2 = variant.product) === null || _variant$product2 === void 0 ? void 0 : _variant$product2.uid) == selectedVariant;
    })) !== null && _product$variants$fin2 !== void 0 ? _product$variants$fin2 : product.variants[0];
  }

  var initialOptionSelections = new Map();

  var _iterator = _createForOfIteratorHelper(product.configurable_options),
      _step;

  try {
    var _loop = function _loop() {
      var _step$value = _step.value,
          attribute_id = _step$value.attribute_id,
          attribute_code = _step$value.attribute_code,
          values = _step$value.values;

      if (targetVariant != undefined) {
        var _targetVariant$attrib;

        // console.log(targetVariant);
        // console.log(targetVariant.attributes.find( attribute => attribute.code == attribute_code ));
        initialOptionSelections.set(attribute_id, (_targetVariant$attrib = targetVariant.attributes.find(function (attribute) {
          return attribute.code == attribute_code;
        })) === null || _targetVariant$attrib === void 0 ? void 0 : _targetVariant$attrib.value_index);
      } else {
        initialOptionSelections.set(attribute_id, values[0].value_index);
      }
    };

    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      _loop();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return initialOptionSelections;
};
export var deriveOptionSelectionsFromVariant = function deriveOptionSelectionsFromVariant(product, targetVariant) {
  if (!isProductConfigurable(product) || !targetVariant) {
    return false;
  }

  var optionSelections = new Map();

  var _iterator2 = _createForOfIteratorHelper(product.configurable_options),
      _step2;

  try {
    var _loop2 = function _loop2() {
      var _targetVariant$attrib2;

      var _step2$value = _step2.value,
          attribute_id = _step2$value.attribute_id,
          attribute_code = _step2$value.attribute_code,
          values = _step2$value.values;
      optionSelections.set(attribute_id, (_targetVariant$attrib2 = targetVariant.attributes.find(function (attribute) {
        return attribute.code == attribute_code;
      })) === null || _targetVariant$attrib2 === void 0 ? void 0 : _targetVariant$attrib2.value_index);
    };

    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop2();
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return optionSelections;
}; // Outlet SKU prefixes assigned by Epicor, mirroring Jola\EpicorIntegration\Model\OutletSku on the
// backend. OUT- is a regular Outlet item (return or cancelled order) and DIS- is a Retired Design
// (discontinued) item. Both are outlet products everywhere else (pricing, shipping, cart rules).

export var OUTLET_PREFIX = 'OUT-';
export var RETIRED_DESIGN_PREFIX = 'DIS-';
export var OUTLET_SKU_PREFIXES = [OUTLET_PREFIX, RETIRED_DESIGN_PREFIX]; // Matches the prefix plus the part number, for example "OUT-131606" in "OUT-131606-1013".

export var OUTLET_BASE_SKU_REGEX = /^(?:OUT|DIS)-[^-]+/;

var getOutletPrefix = function getOutletPrefix(sku) {
  return typeof sku === 'string' ? OUTLET_SKU_PREFIXES.find(function (prefix) {
    return sku.startsWith(prefix);
  }) : undefined;
};

export var isOutletSku = function isOutletSku(sku) {
  return !!getOutletPrefix(sku);
};
export var isRetiredDesignSku = function isRetiredDesignSku(sku) {
  return typeof sku === 'string' && sku.startsWith(RETIRED_DESIGN_PREFIX);
}; // The SKU without its outlet prefix; a non-outlet SKU is returned unchanged.

export var stripOutletPrefix = function stripOutletPrefix(sku) {
  var prefix = getOutletPrefix(sku);
  return prefix ? sku.slice(prefix.length) : sku;
}; // hf_hot_deal (Final Call) is a boolean attribute: 1 when tagged, 0 or empty when not

export var isFinalCallValue = function isFinalCallValue(value) {
  return value === 1 || value === '1' || value === true;
}; // Outlet tag categories under Outlet, created by the backend AddOutletTagCategories patch. They are
// matched by URL key (category IDs differ between environments) and always listed first, in this
// order. "outlet-items" is shown as "Outlet".

export var OUTLET_TAG_CATEGORIES = [{
  urlKey: 'final-call',
  label: 'Final Call'
}, {
  urlKey: 'retired-designs',
  label: 'Retired Designs'
}, {
  urlKey: 'outlet-items',
  label: 'Outlet'
}];

var getCategoryUrlKey = function getCategoryUrlKey(category) {
  var _category$url_path;

  return (category === null || category === void 0 ? void 0 : category.url_key) || (category === null || category === void 0 ? void 0 : (_category$url_path = category.url_path) === null || _category$url_path === void 0 ? void 0 : _category$url_path.split('/').pop()) || '';
}; // The OUTLET_TAG_CATEGORIES entry for a category, or undefined for a regular (room-type) category.


export var getOutletTagCategory = function getOutletTagCategory(category) {
  return OUTLET_TAG_CATEGORIES.find(function (tag) {
    return tag.urlKey === getCategoryUrlKey(category);
  });
}; // Splits Outlet subcategories into the tag categories (in OUTLET_TAG_CATEGORIES order) and the rest.

export var splitOutletTagCategories = function splitOutletTagCategories() {
  var categories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var getCategory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (category) {
    return category;
  };
  var tagCategories = OUTLET_TAG_CATEGORIES.map(function (tag) {
    return categories.find(function (item) {
      var _getOutletTagCategory;

      return ((_getOutletTagCategory = getOutletTagCategory(getCategory(item))) === null || _getOutletTagCategory === void 0 ? void 0 : _getOutletTagCategory.urlKey) === tag.urlKey;
    });
  }).filter(Boolean);
  var otherCategories = categories.filter(function (item) {
    return !getOutletTagCategory(getCategory(item));
  });
  return {
    tagCategories: tagCategories,
    otherCategories: otherCategories
  };
};
export var isOutletFromSKU = isOutletSku; // Image types inside hf_internal_images_block that hold CAD drawings. Every
// other block in that attribute holds a Revit family, which is the same rule
// the Resources page has always used.

var CAD_IMAGE_TYPES = ['2d cad', '3d cad'];

var getDesignFilePath = function getDesignFilePath(file) {
  return typeof file === 'string' ? file : file === null || file === void 0 ? void 0 : file.path;
};

var getDesignFileLabel = function getDesignFileLabel(type, imageType) {
  if (type === 'revit') return 'REVIT File';

  switch (imageType === null || imageType === void 0 ? void 0 : imageType.toLowerCase()) {
    case '2d cad':
      return '2D CAD File';

    case '3d cad':
      return '3D CAD File';

    default:
      return 'CAD File';
  }
};
/**
 * Parses the hf_internal_images_block product attribute into the flat list of
 * CAD and Revit assets it holds, in the order the PIM returns them. Blocks
 * without a resolvable file path are dropped, because they can only ever build
 * a broken asset URL.
 *
 * @param {string} internalImagesBlock JSON string from hf_internal_images_block.
 * @returns {Array<{path: string, fileName: string, type: string, format: string, label: string, size: *, date: *}>}
 */


export var parseProductDesignFiles = function parseProductDesignFiles(internalImagesBlock) {
  if (!internalImagesBlock) return [];
  var blocks;

  try {
    blocks = JSON.parse(internalImagesBlock);
  } catch (error) {
    return [];
  }

  if (!Array.isArray(blocks)) return [];
  return blocks.reduce(function (designFiles, block) {
    var _block$ProductImageFi, _block$ImageType;

    var file = block === null || block === void 0 ? void 0 : (_block$ProductImageFi = block.ProductImageFiles) === null || _block$ProductImageFi === void 0 ? void 0 : _block$ProductImageFi[0];
    var path = getDesignFilePath(file);
    if (!path) return designFiles;
    var type = CAD_IMAGE_TYPES.includes(block === null || block === void 0 ? void 0 : (_block$ImageType = block.ImageType) === null || _block$ImageType === void 0 ? void 0 : _block$ImageType.toLowerCase()) ? 'cad' : 'revit';
    designFiles.push({
      path: path,
      fileName: path.split('/').pop(),
      type: type,
      format: type === 'cad' ? 'DWG' : 'RFA',
      label: getDesignFileLabel(type, block === null || block === void 0 ? void 0 : block.ImageType),
      size: file === null || file === void 0 ? void 0 : file.size,
      date: file === null || file === void 0 ? void 0 : file.lastUpdated
    });
    return designFiles;
  }, []);
};